export enum VasMessageType {
  SET_DESTINATION_ADDRESS_GSM,
  SET_SERVICE_CENTER_ADDRESS_GSM,
  MODIFY_FLASH,
  SEND_50_BYTE_DUMMY_DATA,
  SEND_GPS_SCHEDULE,
  SEND_VHF_SCHEDULE,
  SEND_GSM_COMMUNICATION_SCHEDULE,
  SEND_VIRTUAL_FENCE_POLYGON,
  SEND_PROXIMITY_SCHEDULE,

  SET_PARAMETER,
  SET_LONG_PARAMETER,
  SET_GPS_SCHEDULE,
  SET_VHF_SCHEDULE,
  SET_COMMUNICATION_SCHEDULE,
  SET_VIRTUAL_FENCE,
  SET_PROXIMITY_GPS_SCHEDULE,
  SET_EXTERNAL_SENSOR_RECEIVER_SCHEDULE,
  SET_CAMERA_SCHEDULE,
  DEVICE_COMMAND,
  SET_ACTIVITY_GPS_SCHEDULE,
}
